import { type ReactNode, useMemo } from 'react';

interface SuspenseProps {
  fallback?: ReactNode;
  condition: any;
  children: ReactNode;
}

const SyncSuspense = ({ fallback, condition, children }: SuspenseProps): ReactNode => {
  const memo = useMemo(() => condition, [condition]);
  return memo ? children : fallback;
};

export default SyncSuspense;
